<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <h1>Subscriptions</h1>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <h2>Yarlow Pro Subscription</h2>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <p>You are currently subscribed as a:</p>
        <p v-if="premium">Yarlow Pro Subscription Growth</p>
        <p v-else>Yarlow Pro Free Subscription</p>
        <!--<p>Subscription details:</p>-->
      </div>
    </div>
    <!--<div class="row">
      <div class="col-lg-8">
        <p>Item:</p>
      </div>
      <div class="col-lg-2">
        <p>No. of Units</p>
      </div>
      <div class="col-lg-2">
        <p>Total/Month</p>
      </div>
    </div>
    <hr>
    <div class="row">
      <div class="col-lg-8">
        <p>Custom in-app coupons for your customers</p>
      </div>
      <div class="col-lg-2">
        <p>3 Scanners</p>
      </div>
      <div class="col-lg-2">
        <p>$150</p>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-8">
        <p>Push Notification Ad to your customers</p>
      </div>
      <div class="col-lg-2">
        <p>Not Opted</p>
      </div>
      <div class="col-lg-2">
        <p>$0</p>
      </div>
    </div>
    <hr>
    <div class="row">
      <div class="col-lg-10">
        <p>Subscription Monthly Total</p>
      </div>
      <div class="col-lg-2">
        <p>$150</p>
      </div>
    </div>-->
    <div class="row">
      <div class="col">
        <router-link v-if="premium" tag="button" to="/profile/serviceprovider/checkout" class="btn btn-primary">Modify Subscription</router-link>
        <router-link v-else tag="button" to="/profile/serviceprovider/checkout" class="btn btn-primary">Subscribe</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters('serviceProvider', [
      'getPremium'
    ]),
    premium () {
      return this.getPremium
    }
  }
}
</script>

<style scoped>
.bold-text {
  font-weight: bold;
  margin-bottom: 0;
}

.btn {
  margin-top: 0px !important;
}

.container {
  margin-bottom: 3rem !important;
  border-radius: 25px;
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.price {
  font-size: 1.5rem;
}

.product {
  padding-top: .5rem;
  padding-bottom: .5rem;
  padding-left: 2rem;
  padding-right: 2rem;
  border-radius: 10px;
}

.small-bottom-margin {
  margin-bottom: 1.5rem;
}

.sub-header {
  margin-bottom: 0;
  margin-top: 2rem;
}

.top-margin {
  margin-top: 1.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/profile/serviceProviderProfile/ServiceProviderSubscriptions.vue